import React from 'react';
import { motion } from 'framer-motion';
import { USE_CASES } from './salesData';
export function TestimonialsSection() {
  return <section className="bg-ivory py-12 sm:py-16" data-id="element-193" data-mp="20qxeffb1wsvc">
      <div className="mx-auto max-w-5xl px-5" data-id="element-194" data-mp="1n0aejjtk0wxo">
        <h2 className="text-center font-display text-[1.7rem] font-semibold leading-tight text-charcoal sm:text-[2.2rem]" data-id="element-195" data-mp="1mziun69bknn8">
          Así podés aplicar Wellness Digital PRO
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center font-sans text-sm leading-relaxed text-charcoal/70" data-id="element-196" data-mp="1d0tepj0zhd9m">
          Tres ejemplos de aplicación del sistema según la disciplina. Son casos de uso
          ilustrativos, no experiencias de clientes.
        </p>

        <div className="mt-7 grid gap-3 sm:grid-cols-3" data-id="element-197" data-mp="182i1cybhckmn">
          {USE_CASES.map((useCase, i) => <motion.article key={useCase.role} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex h-full flex-col rounded-xl border border-stone bg-sand/50 p-4" data-id="element-198" data-mp="2yfgzsz1dmpj6" data-mpi={i}>
              <p className="font-sans text-[0.6rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-199" data-mp="34re27lvrqiyf">
                Ejemplo {i + 1}
              </p>
              <h3 className="mt-1.5 font-display text-lg font-semibold leading-tight text-charcoal" data-id="element-200" data-mp="2zst0fi0vbr7v">
                {useCase.role}
              </h3>
              <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-charcoal/70" data-id="element-201" data-mp="273vjpjcb22h8">
                {useCase.desc}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}